import React from 'react'
import Layout from '../../../components/common/pageLayout'
import Form from '../../../components/MasterData/CompanyType/add'
import { v3_add_company_type } from '../../../actions/v3/masterData'
import constant from '../../../constant'
import { toast } from 'react-toastify'
const Add = (props) => {

    const onSubmit = (model) => {
        v3_add_company_type(model).then((res) => {
            if (res.status) {
                toast.success(res.result.message)
                props.history.push(constant.Authedcomponent.listCompanyTypeMasterData.url)
            }
            else{
                toast.error(res.error)

            }
        })
    }
    return (
        <React.Fragment>
            <Layout
                title={'Add Company Type'}
            >
                <Form
                     title={'Add Company Type'}
                     onSubmit={onSubmit}
                     buttonName={'Create Company Type'}
                />
            </Layout>
        </React.Fragment>
    )
}

export default Add